import { Component, computed, effect, inject, input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { of } from 'rxjs';

import { rxResourceFixed, CurrencyService, SkeletonComponent } from '@zayan-erp/shared';
import { DsmApsService } from '../../services/dsm-aps.service';
import { DsmRecentContractsService } from '../../services/dsm-recent-contracts.service';

@Component({
  selector: 'dsm-aps-buyer-contracts',
  templateUrl: './dsm-aps-buyer-contracts.component.html',
  providers: [DatePipe],
  imports: [CommonModule, SkeletonComponent]
})
export class DsmApsBuyerContractsComponent {
  dealId = input.required<string>();

  #service = inject(DsmApsService);
  #datePipe = inject(DatePipe);
  #currencyService = inject(CurrencyService);
  #recentContracts = inject(DsmRecentContractsService);

  contractsResource = rxResourceFixed({
    params: () => ({ dealId: this.dealId() }),
    defaultValue: null,
    stream: ({ params }) => {
      if (!params.dealId) return of(null);
      return this.#service.getBuyerContracts(params.dealId, false);
    }
  });

  contracts = computed(() => this.contractsResource.value());
  isLoading = computed(() => this.contractsResource.isLoading());

  constructor() {
    // Update the recently viewed entry with the contract date once it loads
    effect(() => {
      const data = this.contracts();
      if (data?.contractDate) {
        this.#recentContracts.updateContractDate(this.dealId(), data.contractDate);
      }
    });
  }

  fmt(value: string | null | undefined): string {
    return value ? (this.#datePipe.transform(value, 'MMM d, yyyy') ?? '—') : '—';
  }

  fmtAmount(value: number | null | undefined): string {
    return this.#currencyService.formatCurrency(value ?? 0, '1.2-2') || '—';
  }
}
